import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Route',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Route',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Route',
    column_type: 'datetime',
  },
  destination: {
    model_name: 'Route',
    column_type: 'belongs_to',
    extra: {
      association_name: 'destination',
      model_name: 'Station',
    },
  },
  destination_id: {
    model_name: 'Route',
    column_type: 'belongs_to',
    extra: {
      association_name: 'destination',
      model_name: 'Station',
    },
  },
  origin: {
    model_name: 'Route',
    column_type: 'belongs_to',
    extra: {
      association_name: 'origin',
      model_name: 'Station',
    },
  },
  origin_id: {
    model_name: 'Route',
    column_type: 'belongs_to',
    extra: {
      association_name: 'origin',
      model_name: 'Station',
    },
  },
  active: {
    model_name: 'Route',
    column_type: 'boolean',
  },
  round_trip: {
    model_name: 'Route',
    column_type: 'boolean',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
